// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header___eQbu","content":"ManualTimeModal_content__3ESqd"};